<script setup lang="ts">
const props = defineProps({
  /**
   * @values info, success, warning, danger
   */
  type: {
    type: String,
    default: 'info',
    validator (value: string) {
      return ['info', 'success', 'warning', 'danger', 'primary', 'basic'].includes(value)
    }
  },
  modelValue: {
    required: false,
    default: false
  }
})

const emit = defineEmits(['update:modelValue'])

const isOpen = ref(props.modelValue)

const toggle = () => {
  isOpen.value = !isOpen.value
  emit('update:modelValue', isOpen.value)
}
</script>

<template>
  <div class="relative px-4 mt-4 mb-4 text-sm leading-relaxed callout rounded-xl" :class="[type]" :key="type">
    <span class="flex items-center justify-between callout-title" @click="toggle">
      <MDCSlot name="summary" />
      <Icon name="heroicons-outline:chevron-right" class="w-5 h-5 transition-transform transform" :class="{
        'rotate-90': isOpen,
      }" />
    </span>

    <div v-show="isOpen" class="-mt-4 callout-content">
      <MDCSlot name="content" />
    </div>
  </div>
</template>

<style scoped lang="postcss">
.basic {
  @apply text-primary-500 border border-primary-100 bg-primary-50 text-base px-0;
}

.basic .callout-title {
  @apply px-4;
}

.basic .callout-content {
  @apply bg-white w-full p-4 mt-0 pt-2 text-gray-900 rounded-lg;
}
</style>
